"use client"

import type { FunctionComponent } from "react"

import Skeleton from "react-loading-skeleton"

import styles from "./RegistrationDetails.module.css"

export const RegistrationDetailsPlaceholder: FunctionComponent = () => {
  return (
    <Skeleton
      height="120px"
      containerTestId="registration-details-placeholder"
      containerClassName={styles.registrationDetailsPlaceholder}
    />
  )
}
